module.exports = __webpack_public_path__ + "604bb3c44ede062b803c4a32e6608ca5.svg";